export default __webpack_public_path__ + "static/media/1381.04e02e2f.png";